
import { useState } from 'react';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function AboutContent() {
  const [activeTab, setActiveTab] = useState('company');

  const teamMembers = [
    {
      name: 'YAKINDA',
      position: 'CEO - Genel Müdür',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Turkish%20businessman%20CEO%20in%20modern%20office%20environment%2C%20sustainability%20expert%20wearing%20business%20suit%2C%20confident%20leader%20in%20corporate%20setting%2C%20clean%20professional%20headshot&width=300&height=300&seq=301&orientation=squarish',
      description: 'Çevre Mühendisi ve Sürdürülebilirlik alanında doktora derecesi. ECOVENTRA\'nın kurucusu ve vizyoner lideri.',
      expertise: ['Sürdürülebilirlik Stratejisi', 'ESG Danışmanlığı', 'GRI Raporlama', 'Kurumsal Yönetim']
    },
    {
      name: 'YAKINDA',
      position: 'COO - Operasyon Direktörü',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Turkish%20businesswoman%20COO%20in%20modern%20office%2C%20sustainability%20operations%20director%20wearing%20business%20attire%2C%20confident%20female%20executive%2C%20clean%20professional%20headshot&width=300&height=300&seq=302&orientation=squarish',
      description: 'Endüstri Mühendisi, sürdürülebilirlik alanında uzman. Operasyonel süreçlerin yönetiminden sorumlu.',
      expertise: ['Operasyon Yönetimi', 'Proje Koordinasyonu', 'Kalite Kontrolü', 'İş Süreçleri']
    },
    {
      name: 'YAKINDA',
      position: 'CTO - Teknoloji Direktörü',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Turkish%20software%20engineer%20CTO%20in%20modern%20tech%20office%2C%20sustainability%20technology%20director%20wearing%20casual%20business%20attire%2C%20innovative%20tech%20leader%2C%20clean%20professional%20headshot&width=300&height=300&seq=303&orientation=squarish',
      description: 'Yazılım Mühendisi, SUSTAINES yazılımının geliştirilmesinden ve teknoloji çözümlerinden sorumlu.',
      expertise: ['Yazılım Geliştirme', 'Veri Analizi', 'Dijital Dönüşüm', 'Teknoloji Stratejisi']
    },
    {
      name: 'YAKINDA',
      position: 'Baş GRI Uzmanı',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Turkish%20female%20GRI%20sustainability%20expert%20in%20modern%20office%2C%20sustainability%20reporting%20specialist%20wearing%20business%20attire%2C%20confident%20environmental%20consultant%2C%20clean%20professional%20headshot&width=300&height=300&seq=304&orientation=squarish',
      description: 'GRI standartları uzmanı, sürdürülebilirlik raporlama süreçlerinde lider. Raporlama deneyimi.',
      expertise: ['GRI Standartları', 'TSRS Raporlama', 'CSRD Uyumu', 'Sürdürülebilirlik Raporları']
    },
    {
      name: 'YAKINDA',
      position: 'Karbon ve İklim Uzmanı',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Turkish%20environmental%20engineer%20carbon%20footprint%20specialist%20in%20modern%20office%2C%20climate%20expert%20wearing%20business%20attire%2C%20environmental%20consultant%20with%20sustainable%20background%2C%20clean%20professional%20headshot&width=300&height=300&seq=305&orientation=squarish',
      description: 'Çevre Mühendisi, karbon ayak izi hesaplama ve iklim değişikliği stratejilerinde uzman.',
      expertise: ['Karbon Ayak İzi', 'İklim Stratejisi', 'ISO 14064-1', 'SBTi Hedefleri']
    },
    {
      name: 'YAKINDA',
      position: 'ESG ve Finans Uzmanı',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Turkish%20female%20ESG%20finance%20expert%20in%20modern%20office%2C%20sustainable%20finance%20specialist%20wearing%20business%20attire%2C%20confident%20financial%20consultant%2C%20clean%20professional%20headshot&width=300&height=300&seq=306&orientation=squarish',
      description: 'İktisat Mezunu, ESG kriterleri ve sürdürülebilir finans alanında uzman. Yatırımcı ilişkileri sorumlusu.',
      expertise: ['ESG Analizi', 'Sürdürülebilir Finans', 'Yatırımcı İlişkileri', 'Risk Yönetimi']
    }
  ];

  const partners = [
    {
      name: 'Global Reporting Initiative (GRI)',
      description: 'GRI tarafından yetkilendirilmiş partner olarak uluslararası sürdürülebilirlik raporlama standartlarında hizmet veriyoruz. Türkiye\'de GRI Certified Partner sıfatı ile hizmet veren öncü şirketlerdeniz.',
      image: 'https://readdy.ai/api/search-image?query=GRI%20Global%20Reporting%20Initiative%20official%20logo%20and%20certification%20badge%2C%20professional%20sustainability%20reporting%20standards%20organization%20emblem%2C%20clean%20corporate%20identity&width=200&height=100&seq=307&orientation=landscape',
      benefits: ['Uluslararası Tanınırlık', 'Güncel Standartlar', 'Uzman Eğitimler', 'Global Network']
    },
    {
      name: 'TÜV Austria',
      description: 'Kurumsal Karbon Ayak İzi ve Su Ayak İzi doğrulamasında 17029 AB Akreditasyonuna sahip TÜV Avusturya\'nın Türkiye partneri. ISO 14064-1 standardında doğrulama yetkisi.',
      image: 'https://readdy.ai/api/search-image?query=TUV%20Austria%20certification%20logo%20and%20premium%20partner%20badge%2C%20professional%20quality%20assurance%20and%20verification%20organization%20emblem%2C%20clean%20corporate%20identity&width=200&height=100&seq=308&orientation=landscape',
      benefits: ['AB Akreditasyonu', 'Doğrulama Yetkisi', 'Kalite Güvencesi', 'Teknik Destek']
    },
    {
      name: 'Responsible Program',
      description: 'Ticaret Bakanlığı tarafından yürütülen Responsible Programında FAZ-1 Sürdürülebilirlik Danışmanlık şirketi olarak yetkilendirilmiş. İhracat yapan firmalara %50 hibe destekli danışmanlık.',
      image: 'https://readdy.ai/api/search-image?query=Turkish%20Ministry%20of%20Trade%20Responsible%20Program%20official%20certification%20badge%2C%20government%20sustainability%20program%20emblem%2C%20clean%20official%20design&width=200&height=100&seq=309&orientation=landscape',
      benefits: ['Devlet Desteği', '%50 Hibe', 'İhracat Avantajı', 'Resmi Yetkilendirme']
    },
    {
      name: 'SimaPro & PRé Sustainability',
      description: 'SimaPro yazılımının lisanslı kullanıcısı ve PRé Sustainability\'in Türkiye partneri. Ürün Yaşam Döngüsü Analizi - LCA çalışmalarında kullanılan dünya\'nın önde gelen profesyonel yazılımı.',
      image: 'https://readdy.ai/api/search-image?query=SimaPro%20software%20logo%20and%20Pre%20Sustainability%20partnership%20badge%2C%20professional%20LCA%20life%20cycle%20assessment%20tool%20emblem%2C%20clean%20software%20identity&width=200&height=100&seq=310&orientation=landscape',
      benefits: ['Profesyonel Yazılım', 'LCA Uzmanlığı', 'Veri Tabanları', 'Teknik Güncelleme']
    },
    {
      name: 'CDP Worldwide',
      description: 'Carbon Disclosure Project\'in Türkiye\'deki önemli danışmanlık partnerlerinden biri. CDP iklim, su ve orman raporlama süreçlerinde A seviye skorlar elde etme konusunda uzman.',
      image: 'https://readdy.ai/api/search-image?query=CDP%20Carbon%20Disclosure%20Project%20official%20logo%20and%20partnership%20badge%2C%20professional%20climate%20reporting%20organization%20emblem%2C%20clean%20environmental%20identity&width=200&height=100&seq=311&orientation=landscape',
      benefits: ['CDP A-List Deneyimi', 'İklim Raporlama', 'Su Güvenliği', 'Orman Koruma']
    },
    {
      name: 'Science Based Targets initiative (SBTi)',
      description: 'SBTi metodolojisinde uzman danışmanlık hizmeti sunan Türkiye\'deki sınırlı sayıda şirket arasında. Bilim temelli karbon hedefleri belirleme ve doğrulama süreçlerinde deneyimli.',
      image: 'https://readdy.ai/api/search-image?query=Science%20Based%20Targets%20initiative%20SBTi%20official%20logo%20and%20certification%20badge%2C%20professional%20climate%20target%20setting%20organization%20emblem%2C%20clean%20scientific%20identity&width=200&height=100&seq=312&orientation=landscape',
      benefits: ['Bilim Temelli Hedefler', 'Net Zero Stratejisi', 'Uluslararası Doğrulama', 'İklim Liderliği']
    }
  ];

  const milestones = [
    { 
      year: '2021', 
      title: 'Şirket Kuruluşu', 
      description: 'ECOVENTRA, sürdürülebilirlik alanında uzman genç profesyoneller tarafından İstanbul\'da kuruldu.',
      icon: 'ri-rocket-line'
    },
    { 
      year: '2022', 
      title: 'İlk GRI Raporu', 
      description: 'Türkiye\'nin önde gelen şirketlerinden biri için ilk GRI uyumlu sürdürülebilirlik raporunu hazırladık.',
      icon: 'ri-file-text-line'
    },
    { 
      year: '2023', 
      title: 'GRI Certified Partner', 
      description: 'Global Reporting Initiative tarafından Certified Partner olarak yetkilendirildik.',
      icon: 'ri-award-line'
    },
    { 
      year: '2024', 
      title: 'Hızlı Büyüme', 
      description: 'Start-up ruhumuzla 50\'nci müşterimize ulaşarak Türkiye\'nin yükselen sürdürülebilirlik danışmanlık şirketleri arasına girdik.',
      icon: 'ri-trophy-line'
    },
    { 
      year: '2024', 
      title: 'TÜV Austria Partnership', 
      description: 'TÜV Austria ile partner anlaşması imzalayarak doğrulama hizmetlerini bünyemize kattık.',
      icon: 'ri-shield-check-line'
    },
    { 
      year: '2024', 
      title: 'TSRS Erken Adaptörü', 
      description: 'Türkiye Sürdürülebilirlik Raporlama Standartları\'nın erken adaptörü olarak ilk TSRS raporlarını hazırladık.',
      icon: 'ri-flag-line'
    },
    { 
      year: '2025', 
      title: 'CSRD Hazırlık Lideri', 
      description: 'AB\'nin CSRD direktifine hazırlık sürecinde Türkiye\'deki öncü danışmanlık şirketi olduk.',
      icon: 'ri-europe-line'
    },
    { 
      year: '2025', 
      title: 'Yeni Hedefler', 
      description: '100+ şirkete hizmet verme hedefiyle sürdürülebilirlik alanında güçlü büyüme stratejimizi hayata geçiriyoruz.',
      icon: 'ri-line-chart-line'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section 
        className="relative py-32 bg-cover bg-center"
        style={{ 
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Modern%20sustainable%20office%20building%20with%20green%20architecture%20and%20solar%20panels%2C%20professional%20business%20environment%20with%20natural%20lighting%20and%20plants%2C%20corporate%20sustainability%20headquarters%2C%20clean%20minimal%20design&width=1200&height=600&seq=100&orientation=landscape)' 
        }}
      >
        <div className="absolute inset-0 bg-emerald-900/80"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-white mb-6 animate-in fade-in slide-in-from-bottom-8 duration-1000">
            ECOVENTRA Hakkında
          </h1>
          <p className="text-xl text-emerald-100 max-w-3xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
            Yenilikçi yaklaşımlarla sürdürülebilirlik alanında öncü, dinamik ve çözüm odaklı 
            Türkiye'nin genç sürdürülebilirlik danışmanlık şirketi
          </p>
        </div>
      </section>

      {/* Navigation Tabs */}
      <section className="bg-white border-b sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center space-x-8 py-4">
            {[
              { id: 'company', name: 'Şirket', icon: 'ri-building-line' },
              { id: 'team', name: 'Ekibimiz', icon: 'ri-team-line' },
              { id: 'partners', name: 'Partnerlerimiz', icon: 'ri-handshake-line' },
              { id: 'timeline', name: 'Tarihçemiz', icon: 'ri-time-line' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                  activeTab === tab.id
                    ? 'bg-emerald-600 text-white'
                    : 'text-gray-600 hover:text-emerald-600'
                }`}
              >
                <i className={`${tab.icon} text-sm`}></i>
                <span>{tab.name}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Company Info */}
      {activeTab === 'company' && (
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
              <div className="animate-in fade-in slide-in-from-left duration-1000">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Sürdürülebilirlikte Yenilikçi Yaklaşım
                </h2>
                <div className="prose prose-emerald max-w-none">
                  <p className="text-lg text-gray-600 leading-relaxed mb-4">
                    <strong>ECOVENTRA</strong>, sürdürülebilirlik danışmanlığı alanında yenilikçi çözümler sunan 
                    dinamik bir start-up şirketidir. Modern yaklaşımlarla işletmelerin çevresel, sosyal ve ekonomik 
                    performanslarını iyileştirmelerine yardımcı oluyoruz.
                  </p>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    <strong>Sürdürülebilirlik Danışmanlığının</strong> çevresel, sosyal ve ekonomik boyutlarında 
                    uzmanlaşmış ekibimizle, kendimizi <em>"Yeni Nesil Sürdürülebilirlik Danışmanlık Şirketi"</em> 
                    olarak konumlandırıyoruz.
                  </p>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    İstanbul merkezli ofisimizden hareketle Türkiye'nin genelinde hizmet vermekteyiz. 
                    Avrupa Birliği ülkelerine de hizmet veren ECOVENTRA, global Sürdürülebilirlik 
                    Danışmanlık şirketi olma yolunda kararlı adımlarla ilerlemektedir.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    <strong>GRI (Global Reporting Initiative)</strong> tarafından yetkilendirilmiş partner olarak, 
                    <strong>TÜV Austria Partner</strong> sıfatıyla ve <strong>Responsible Program Yetkili Şirket</strong> 
                    olarak uluslararası standartlarda hizmet sunmaktadır.
                  </p>
                </div>
              </div>
              <div className="animate-in fade-in slide-in-from-right duration-1000 delay-300">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20sustainability%20consulting%20team%20in%20modern%20office%20with%20green%20plants%20and%20sustainability%20charts%2C%20diverse%20business%20professionals%20working%20together%2C%20corporate%20environmental%20responsibility%2C%20clean%20office%20environment&width=600&height=400&seq=101&orientation=landscape"
                  alt="ECOVENTRA Ofis"
                  className="rounded-2xl shadow-xl"
                />
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
              {[
                { number: '2021', label: 'Kuruluş Yılı', icon: 'ri-time-line' },
                { number: '100+', label: 'Hedef Müşteri', icon: 'ri-customer-service-2-line' },
                { number: '5', label: 'Ülkede Hizmet', icon: 'ri-global-line' },
                { number: '15+', label: 'Uzman Ekip', icon: 'ri-team-line' }
              ].map((stat, index) => (
                <Card key={index} className="text-center p-6 hover:shadow-lg transition-all duration-300">
                  <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${stat.icon} text-2xl text-emerald-600`}></i>
                  </div>
                  <div className="text-3xl font-bold text-emerald-600 mb-2">{stat.number}</div>
                  <div className="text-gray-600 font-medium">{stat.label}</div>
                </Card>
              ))}
            </div>

            {/* Vision & Mission */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <Card className="p-8">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-eye-line text-3xl text-emerald-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Vizyonumuz</h3>
                <p className="text-gray-600 leading-relaxed">
                  Sürdürülebilirlik alanında Türkiye'nin yenilikçi danışmanlık şirketi olarak, modern yaklaşımlarla 
                  global standartlarda hizmet vererek işletmelerin çevresel, sosyal ve ekonomik performanslarını 
                  iyileştirmek. 2030 yılına kadar 500+ şirkete ulaşarak Türkiye'nin sürdürülebilir kalkınma 
                  hedeflerine katkıda bulunmak.
                </p>
              </Card>
              
              <Card className="p-8">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-target-line text-3xl text-emerald-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Misyonumuz</h3>
                <p className="text-gray-600 leading-relaxed">
                  İşletmelere yenilikçi sürdürülebilirlik danışmanlığı sunarak, GRI, TSRS, CSRD gibi uluslararası 
                  standartlara uyum sağlamalarını desteklemek. Teknoloji odaklı çözümlerle sürdürülebilirlik 
                  yolculuklarında güvenilir partneri olmak ve pozitif çevresel-sosyal etki yaratmalarını sağlamak.
                </p>
              </Card>
            </div>
          </div>
        </section>
      )}

      {/* Team Section */}
      {activeTab === 'team' && (
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Uzman Ekibimiz</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Alanında uzman, dinamik ve yenilikçi ekibimizle sürdürülebilirlik yolculuğunuzda yanınızdayız
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {teamMembers.map((member, index) => (
                <Card 
                  key={index} 
                  className="p-6 text-center group hover:shadow-xl transition-all duration-300 animate-in fade-in slide-in-from-bottom-4"
                  style={{ animationDelay: `${index * 200}ms` }}
                >
                  <div className="relative mb-6">
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="w-24 h-24 rounded-full mx-auto object-cover group-hover:scale-110 transition-transform duration-300 border-4 border-emerald-100"
                    />
                    <div className="absolute inset-0 rounded-full bg-emerald-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{member.name}</h3>
                  <p className="text-emerald-600 font-medium mb-3">{member.position}</p>
                  <p className="text-sm text-gray-600 leading-relaxed mb-4">{member.description}</p>
                  
                  {/* Expertise Tags */}
                  <div className="flex flex-wrap justify-center gap-1">
                    {member.expertise.map((skill, skillIndex) => (
                      <span 
                        key={skillIndex}
                        className="text-xs px-2 py-1 bg-emerald-50 text-emerald-700 rounded-full"
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Partners Section */}
      {activeTab === 'partners' && (
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Güçlü Partnerlerimiz</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Uluslararası standartlarda hizmet verebilmek için güçlü partnerlerle işbirliği yapıyoruz
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {partners.map((partner, index) => (
                <Card 
                  key={index} 
                  className="p-8 group hover:shadow-xl transition-all duration-300 animate-in fade-in slide-in-from-bottom-4"
                  style={{ animationDelay: `${index * 200}ms` }}
                >
                  <div className="flex items-start space-x-6">
                    <div className="flex-shrink-0">
                      <img 
                        src={partner.image} 
                        alt={partner.name}
                        className="w-24 h-12 object-contain group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors">
                        {partner.name}
                      </h3>
                      <p className="text-gray-600 leading-relaxed mb-4">{partner.description}</p>
                      
                      {/* Benefits */}
                      <div className="grid grid-cols-2 gap-2">
                        {partner.benefits.map((benefit, benefitIndex) => (
                          <div key={benefitIndex} className="flex items-center text-xs text-emerald-600">
                            <i className="ri-check-line mr-1"></i>
                            {benefit}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Timeline Section */}
      {activeTab === 'timeline' && (
        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Başarı Hikayemiz</h2>
              <p className="text-xl text-gray-600">
                2021'den bugüne sürdürülebilirlik alanındaki önemli kilometre taşlarımız
              </p>
            </div>

            <div className="relative">
              {/* Timeline Line */}
              <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-emerald-200"></div>

              {milestones.map((milestone, index) => (
                <div 
                  key={index} 
                  className="relative flex items-start mb-12 animate-in fade-in slide-in-from-left duration-1000"
                  style={{ animationDelay: `${index * 200}ms` }}
                >
                  {/* Timeline Dot */}
                  <div className="relative z-10 w-16 h-16 bg-emerald-600 rounded-full flex flex-col items-center justify-center text-white font-bold text-xs mr-8 flex-shrink-0">
                    <span>{milestone.year}</span>
                    <i className={`${milestone.icon} text-sm mt-1`}></i>
                  </div>
                  
                  {/* Content */}
                  <Card className="flex-1 p-6 hover:shadow-lg transition-all duration-300">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{milestone.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{milestone.description}</p>
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* CTA Section */}
      <section className="relative py-20 overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20sustainable%20business%20office%20with%20green%20plants%2C%20natural%20lighting%2C%20eco-friendly%20workspace%20with%20people%20working%20on%20environmental%20projects%2C%20professional%20atmosphere%20with%20solar%20panels%20visible%20through%20windows%2C%20clean%20minimalist%20design%20with%20wooden%20elements%20and%20living%20walls&width=1200&height=600&seq=about-cta-bg&orientation=landscape')`
          }}
        />
        
        {/* Gradient Overlays */}
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/95 via-emerald-800/90 to-emerald-700/85" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-emerald-900/20 to-emerald-900/40" />
        
        {/* Floating Elements */}
        <div className="absolute top-10 left-10 w-20 h-20 bg-emerald-400/20 rounded-full animate-float" />
        <div className="absolute bottom-20 right-20 w-32 h-32 bg-emerald-300/10 rounded-full animate-float" style={{ animationDelay: '2s' }} />
        <div className="absolute top-1/2 right-10 w-16 h-16 bg-emerald-500/15 rounded-full animate-float" style={{ animationDelay: '4s' }} />

        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-8">
              <div>
                <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                  Sürdürülebilirlik Yolculuğuna Başlayın
                </h2>
                <p className="text-xl text-emerald-50 mb-8 leading-relaxed">
                  Yenilikçi yaklaşımlarımız ve uzman ekibimizle yanınızdayız. Ücretsiz danışmanlık için hemen iletişime geçin.
                </p>
              </div>

              {/* Success Stats */}
              <div className="grid grid-cols-3 gap-6">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                  <div className="text-2xl font-bold text-white">50+</div>
                  <div className="text-sm text-emerald-100">Tamamlanan Proje</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                  <div className="text-2xl font-bold text-white">2021</div>
                  <div className="text-sm text-emerald-100">Kuruluş Yılı</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                  <div className="text-2xl font-bold text-white">%98</div>
                  <div className="text-sm text-emerald-100">Müşteri Memnuniyeti</div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="https://calendly.com/ecoventra"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center justify-center px-8 py-4 bg-white text-emerald-600 font-semibold rounded-xl hover:bg-emerald-50 hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl border-2 border-white/20 whitespace-nowrap"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-3">
                    <i className="ri-calendar-check-line group-hover:scale-110 transition-transform"></i>
                  </div>
                  Online Randevu Al
                  <div className="ml-2 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </a>

                <a
                  href="https://wa.me/905326230183?text=Merhaba, sürdürülebilirlik danışmanlığı hakkında bilgi almak istiyorum."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center justify-center px-8 py-4 bg-emerald-500/20 text-white font-semibold rounded-xl hover:bg-emerald-500/30 hover:scale-105 transition-all duration-300 backdrop-blur-sm border-2 border-emerald-400/30 hover:border-emerald-300/40 whitespace-nowrap"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-3">
                    <i className="ri-whatsapp-line group-hover:scale-110 transition-transform"></i>
                  </div>
                  WhatsApp İletişim
                  <div className="ml-2 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </a>
              </div>

              {/* Contact Info */}
              <div className="flex flex-wrap items-center gap-6 pt-6 border-t border-white/20">
                <div className="flex items-center text-emerald-100">
                  <div className="w-8 h-8 flex items-center justify-center mr-2">
                    <i className="ri-phone-line"></i>
                  </div>
                  <span className="text-sm">+90 543 437 30 49</span>
                </div>
                <div className="flex items-center text-emerald-100">
                  <div className="w-8 h-8 flex items-center justify-center mr-2">
                    <i className="ri-mail-line"></i>
                  </div>
                  <span className="text-sm">info@ecoventra.com</span>
                </div>
              </div>
            </div>

            {/* Right Content - Features */}
            <div className="space-y-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-emerald-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-xl text-emerald-200"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Güvenilir Danışmanlık</h3>
                    <p className="text-emerald-100 text-sm">ISO standardları ve küresel uygulamalarla desteklenen profesyonel hizmet</p>
                  </div>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-emerald-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-team-line text-xl text-emerald-200"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Uzman Ekip</h3>
                    <p className="text-emerald-100 text-sm">Alanında dinamik sürdürülebilirlik uzmanları ile çalışın</p>
                  </div>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-emerald-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-rocket-line text-xl text-emerald-200"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Yenilikçi Çözümler</h3>
                    <p className="text-emerald-100 text-sm">Projenize özel, modern ve etkili sürdürülebilirlik stratejileri</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            33% { transform: translateY(-10px) rotate(1deg); }
            66% { transform: translateY(5px) rotate(-1deg); }
          }
          .animate-float {
            animation: float 6s ease-in-out infinite;
          }
        `}</style>
      </section>
    </div>
  );
}
